<form class="no-padding" [formGroup]="clientInvoiceDraftForm" id="clientInvoiceDraftForm" (ngSubmit)="onSubmit()">
  <div class="grid bgc-neutral-100 p-24 mb-24">
    <div class="d-flex flex-column gap-8 g-col-6">
      <div><span class="fc-neutral-800 fw-500">{{ 'DELIVERY_ADDRESS' | translate | uppercase }}</span></div>
      <div> {{ supplierInvoice()?.deliveryAddressStreet }}</div>
      <div> {{ supplierInvoice()?.deliveryAddressCity }}</div>
      <div> {{ supplierInvoice()?.deliveryAddressCountry }}</div>
    </div>
    <div class="d-flex flex-column gap-8 g-col-6">
      <div><span class="fc-neutral-800 fw-500">{{ 'REFERENCE' | translate | uppercase }}</span></div>
      <div class="d-flex flex-column">
        @for (ref of supplierInvoice()?.references; track ref) {
          <span>{{ ref }}</span>
        }
      </div>
    </div>
  </div>
  <div class="card-body grid p-24">
    <div class="d-flex flex-column g-col-12 g-col-lg-6">
      <kendo-formfield showHints="initial" showErrors="initial">
        <kendo-label
          labelCssClass="k-form-label"
          [for]="client"
          [text]="'CLIENT' | translate | capitalize"></kendo-label>
        @let clients = clients$ | async;
        <kendo-combobox
          rcValidation
          #client
          [data]="getData(clients)"
          [filterable]="true"
          (filterChange)="onSearch($event)"
          [kendoDropDownFilter]="filterSettings"
          [textField]="'name'"
          [valueField]="'@id'"
          [valuePrimitive]="true"
          formControlName="client" />
      </kendo-formfield>
    </div>
    <div class="d-flex flex-column g-col-12 g-col-lg-6">
      <kendo-formfield showHints="initial" showErrors="initial">
        <kendo-label
          labelCssClass="k-form-label"
          [for]="client"
          [text]="'DELIVERY_ADDRESS' | translate | capitalize"></kendo-label>
        @let clientDeliveryAddresses = clientDeliveryAddresses$ | async;
        <kendo-combobox
          rcValidation
          class="{{clientInvoiceDraftForm.value.client ? '' : 'k-disabled'}}"
          #clientDeliveryAddress
          [data]="getData(clientDeliveryAddresses)"
          [kendoDropDownFilter]="filterSettings"
          [filterable]="true"
          [textField]="'name'"
          [valueField]="'@id'"
          [valuePrimitive]="true"
          formControlName="clientDeliveryAddress">
        </kendo-combobox>
      </kendo-formfield>
    </div>
  </div>
</form>
<kendo-dialog-actions>
  <div class="d-flex justify-content-end gap-16">
    <button kendoButton class="g-start-10 string-button" (click)="close()">
      {{ "CANCEL" | translate | capitalize }}
    </button>
    <button
      [disabled]="clientInvoiceDraftForm.invalid"
      class="g-col-2 g-start-11"
      kendoButton
      type="submit"
      form="clientInvoiceDraftForm"
      [iconClass]="'rc-icon-plus'"
      [themeColor]="'primary'">
      {{ "CREATE" | translate | capitalize }}
    </button>
  </div>
</kendo-dialog-actions>
